module.exports = __webpack_public_path__ + "img/advantage1Blue.d5bf6976.png";